import React from 'react'

import Base from '../../_Base'

const Vk16 = (props) => (
  <Base
    aria-hidden="true"
    focusable="false"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        d="M15.623 3.694c.12-.392 0-.676-.525-.676h-1.745c-.44 0-.644.249-.763.516 0 0-.898 2.277-2.152 3.754-.406.427-.593.57-.813.57-.119 0-.271-.143-.271-.534V3.676c0-.462-.136-.676-.509-.676H6.1a.43.43 0 0 0-.44.427c0 .445.627.552.694 1.797V7.93c0 .587-.101.694-.322.694-.593 0-2.033-2.296-2.897-4.911-.17-.516-.339-.712-.78-.712H.593C.085 3 0 3.25 0 3.516c0 .48.593 2.9 2.762 6.103 1.44 2.189 3.49 3.363 5.338 3.363 1.118 0 1.254-.267 1.254-.712v-1.654c0-.534.101-.623.457-.623.254 0 .712.142 1.746 1.192 1.186 1.246 1.39 1.815 2.05 1.815h1.745c.509 0 .746-.267.61-.783-.152-.516-.728-1.263-1.474-2.153-.407-.498-1.017-1.05-1.203-1.317-.254-.356-.186-.498 0-.818-.017 0 2.118-3.167 2.338-4.235"
        fill="black"
        className="logo"
      />
    </g>
  </Base>
)

export default Vk16
